import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, viewChild } from '@angular/core';
import {
  ButtonComponent,
  ConfirmModalComponent,
  EmptyPlaceholderComponent,
  InfoBannerComponent,
} from '@catch/general-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faDesktop,
  faMobile,
  faPlus,
  faShieldKeyhole,
  faTrash,
  faUsbDrive,
} from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { TableModule } from 'primeng/table';
import { illustration } from '../../../../../../assets/animations/animations';
import { PlatformTfaMethodType } from '../../../../enums/platform-tfa-method-type.enum';
import { PlatformTfaMethod, PlatformTfaService } from '../../../../services/platform-tfa.service';
import { PlatformAddTfaModalComponent } from '../add-tfa-modal/platform-add-tfa-modal.component';

const TFA_HELP_URL =
  'https://catchgmbh.freshdesk.com/support/solutions/articles/101000427301-zwei-faktor-authentifizierung';

@Component({
  selector: 'app-platform-settings-tfa',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePipe,
    TableModule,
    FontAwesomeModule,
    InfoBannerComponent,
    ConfirmModalComponent,
    PlatformAddTfaModalComponent,
    TranslocoPipe,
    ButtonComponent,
    EmptyPlaceholderComponent,
  ],
  templateUrl: './platform-settings-tfa.component.html',
  styleUrl: './platform-settings-tfa.component.scss',
  animations: [illustration],
})
export class PlatformSettingsTfaComponent implements OnInit {
  readonly tfaService = inject(PlatformTfaService);
  readonly addMethodModal = viewChild.required<PlatformAddTfaModalComponent>('addMethodModal');
  readonly tfaHelpUrl = TFA_HELP_URL;
  readonly methodTypes = PlatformTfaMethodType;
  readonly icons = {
    plus: faPlus,
    trash: faTrash,
    mobile: faMobile,
    usbDrive: faUsbDrive,
    desktop: faDesktop,
    shieldKeyhole: faShieldKeyhole,
  };

  ngOnInit(): void {
    this.tfaService.loadMethods().subscribe();
  }

  /**
   * Opens the add-method modal.
   */
  openAddMethod(): void {
    this.addMethodModal().open();
  }

  /**
   * Deletes a 2FA method after confirmation.
   * @param method - Method to remove
   */
  onDeleteMethod(method: PlatformTfaMethod): void {
    this.tfaService.deleteMethod(method).subscribe();
  }
}
